<template>
  <v-form ref="mainForm" v-model="valid">
    <data-iterator
      :list="sas.diplomes"
      add-new-text="Ajouter un diplôme"
      :live="{ endpoint: 'sas-diplomes', sasId: sas.id }"
      :icon="$getIcon('school')"
      :valids="valids"
      ref="dataIterator"
    >
      <template v-slot:show-mode="{ item }">
        <h3>
          {{
            item.universite && !estAutreUniversite(item.universite)
              ? getCatalogueValueById(4906, item.universite).text
              : item.autreUniversite
          }}
        </h3>
        <p class="my-0">
          {{
            item.diplome && !estAutreDiplome(item.diplome)
              ? getCatalogueValueById(9223, item.diplome).text
              : item.autreDiplome
          }}
        </p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <opq-catalogue
          code="pays-diplome"
          v-model="item.paysObtention"
          :live="liveSasDiplomes(2702, item)"
          order-by="text"
        >
        </opq-catalogue>
        <opq-catalogue
          :opq-if="paysEstUSouCA(item.paysObtention)"
          code="province-diplome"
          v-model="item.provinceObtention"
          :live="liveSasDiplomes(2703, item)"
          :parent="item.paysObtention"
          order-by="text"
        >
        </opq-catalogue>
        <opq-catalogue code="universite" v-model="item.universite" :live="liveSasDiplomes(2704, item)"> </opq-catalogue>
        <opq-text-field
          :opq-if="estAutreUniversite(item.universite)"
          code="autre-universite"
          v-model="item.autreUniversite"
          :live="liveSasDiplomes(2705, item)"
        ></opq-text-field>
        <opq-catalogue code="diplome" v-model="item.diplome" :live="liveSasDiplomes(2706, item)"> </opq-catalogue>
        <opq-text-field
          :opq-if="estAutreDiplome(item.diplome)"
          code="autre-diplome"
          v-model="item.autreDiplome"
          :live="liveSasDiplomes(2707, item)"
        ></opq-text-field>
        <opq-text-field
          code="duree-programme"
          v-model="item.dureeDuProgramme"
          :live="liveSasDiplomes(2715, item)"
          isNumber
        ></opq-text-field>
        <opq-date-picker
          code="debut-programme"
          hide-day
          v-model="item.dateDebutProgramme"
          :live="liveSasDiplomes(2709, item)"
        ></opq-date-picker>
        <opq-date-picker
          code="fin-programme"
          hide-day
          v-model="item.dateFinProgramme"
          :live="liveSasDiplomes(2710, item)"
          optional
        ></opq-date-picker>
        <opq-catalogue code="diplome-obtenu" v-model="item.diplomeObtenu" :live="liveSasDiplomes(2713, item)">
        </opq-catalogue>
        <opq-date-picker
          :opq-if="estOui(item.diplomeObtenu)"
          code="date-diplome"
          hide-day
          v-model="item.dateObtention"
          :live="liveSasDiplomes(2714, item)"
        ></opq-date-picker>
        <opq-text-field
          code="credits-diplome"
          v-model="item.nombreDeCredits"
          :live="liveSasDiplomes(2716, item)"
          isNumber
        ></opq-text-field>
        <opq-file-multiple
          :opq-if="estOui(item.diplomeObtenu)"
          code="fichier-copie-diplome"
          :files="item.copieDuDiplome"
          :live="liveSasDiplomes(2712, item)"
        >
        </opq-file-multiple>
        <opq-file-multiple code="releve-notes" :files="item.relevesDeNotes" :live="liveSasDiplomes(2717, item)">
        </opq-file-multiple>

        <opq-catalogue
          :opq-if="aBesoinDocumentEtudeComparative(item.paysObtention, item.provinceObtention)"
          code="analyse-comparative-diplome"
          v-model="item.evaluationComparative"
          :live="liveSasDiplomes(2720, item)"
        >
        </opq-catalogue>

        <opq-file
          :opq-if="estOui(item.evaluationComparative)"
          code="analyse-comparative-fichier"
          :live="liveSasDiplomes(2721, item)"
          :file="item.evaluationComparativeDocument"
        ></opq-file>
      </template>
    </data-iterator>
  </v-form>
</template>

<script>
import FormHybrid from "@/mixins/FormHybrid"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
export default {
  mixins: [FormHybrid, CataloguesHelper],
  props: {
    sas: { type: Object },
  },
  methods: {
    liveSasDiplomes(cle, item) {
      return { endpoint: "sas-diplomes", cle: cle, fileId: item.id }
    },
    estAutreUniversite(universite) {
      return this.getCatalogueCodeById(4906, universite) == "autre"
    },
    estAutreDiplome(diplome) {
      return diplome == "JnPHZbChu9Z2CNDTrWQlPQR1EpL1R1EpL1"
    },
    estCanada(pays) {
      return this.getCatalogueCodeById(303, pays) == "CA"
    },
    estQuebec(province) {
      return this.getCatalogueCodeById(313, province) == "QC"
    },
    aBesoinDocumentEtudeComparative(pays, province) {
      if (!this.estCanada(pays) || (this.estCanada(pays) && !this.estQuebec(province))) {
        return true
      } else {
        return false
      }
    },
  },
}
</script>

<style></style>
